"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavLink = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var camelCase_1 = (0, tslib_1.__importDefault)(require("lodash/camelCase"));
var has_1 = (0, tslib_1.__importDefault)(require("lodash/has"));
var flow_1 = (0, tslib_1.__importDefault)(require("lodash/flow"));
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var style_1 = require("./style");
var useAuth_1 = require("../../auth/useAuth");
var NavLinks = function () {
    var ld = (0, launchdarkly_react_client_sdk_1.useFlags)();
    var ntConfig = (0, useAuth_1.useAuth)().ntConfig;
    var navigation = ntConfig.MicroFE.navigation;
    /* TODO: Remove once Research Management is enabled on Prod. */
    var filteredNavigation = (0, react_1.useMemo)(function () {
        return navigation.filter(function (_a) {
            var flag = _a.flag;
            return (0, flow_1.default)(camelCase_1.default, function (f) { return !(0, has_1.default)(ld, [f]) || f === 'rm' || ld[f] === true; })(flag);
        });
    }, [ld, navigation]);
    /* ENDTODO */
    return (react_1.default.createElement(style_1.StyledList, null, (0, react_1.useMemo)(function () {
        return filteredNavigation.map(function (_a) {
            var title = _a.title, path = _a.path, flag = _a.flag;
            var disabled = (0, flow_1.default)(camelCase_1.default, function (f) { return (0, has_1.default)(ld, [f]) && ld[f] === false; })(flag);
            var className = [disabled && 'disabled']
                .filter(Boolean)
                .join(' ');
            return (react_1.default.createElement("li", { key: title.toLowerCase().replace(/\s/g, '-') },
                react_1.default.createElement(exports.StyledNavLink, { className: className, disabled: disabled, to: path, onClick: function (e) {
                        if (disabled)
                            e.preventDefault();
                    } }, title)));
        });
    }, [filteredNavigation, ld])));
};
exports.StyledNavLink = (0, styled_components_1.default)(react_router_dom_1.NavLink)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: inline-block;\n  color: white;\n  text-decoration: none;\n  font-family: 'Roboto Medium', sans-serif;\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 5rem;\n  text-transform: uppercase;\n  transition: box-shadow 0.26s ease;\n  letter-spacing: 0.05rem;\n  white-space: nowrap;\n\n  &.disabled {\n    opacity: 0.3;\n    cursor: default;\n  }\n\n  @media only screen and (min-width: ", ") {\n    &.active {\n      box-shadow: inset 0 -0.4rem 0 white;\n    }\n  }\n"], ["\n  display: inline-block;\n  color: white;\n  text-decoration: none;\n  font-family: 'Roboto Medium', sans-serif;\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 5rem;\n  text-transform: uppercase;\n  transition: box-shadow 0.26s ease;\n  letter-spacing: 0.05rem;\n  white-space: nowrap;\n\n  &.disabled {\n    opacity: 0.3;\n    cursor: default;\n  }\n\n  @media only screen and (min-width: ", ") {\n    &.active {\n      box-shadow: inset 0 -0.4rem 0 white;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.tablet;
});
exports.default = NavLinks;
var templateObject_1;
